// extracted by mini-css-extract-plugin
export default {"container":"v1-z"};